import type {
  IEvaluationKind,
  IProfessorAreaEvaluationsList
} from 'interfaces/professor_area/evaluations';

export function filterRegularEvaluations(
  items: IProfessorAreaEvaluationsList[]
): IProfessorAreaEvaluationsList[] {
  return items.filter(e => e.kind === 'regular');
}

export function totalRegularWeight(
  items: IProfessorAreaEvaluationsList[]
): number {
  return filterRegularEvaluations(items).reduce(
    (sum, e) => sum + Number(e.weight ?? 0),
    0
  );
}

/** Id sintético da avaliação em pré-visualização no modal de criação */
export const PREVIEW_EVALUATION_ID = '__preview__';

/**
 * Junta avaliações já existentes na turma com uma prévia (nova avaliação padrão).
 * Se `preview` for null ou tipo final, devolve só as existentes.
 */
export function mergeEvaluationsWithPreview(
  existing: IProfessorAreaEvaluationsList[],
  preview: {
    name: string;
    weight: number;
    kind: IEvaluationKind;
    evaluation_type?: 'Assessment' | 'Assignment';
  } | null
): IProfessorAreaEvaluationsList[] {
  const base = existing.filter(e => e.id !== PREVIEW_EVALUATION_ID);

  if (!preview || preview.kind !== 'regular') {
    return base;
  }

  const evaluationType = preview.evaluation_type ?? 'Assessment';
  const fallbackName =
    evaluationType === 'Assignment' ? 'Esta atividade' : 'Esta avaliação';

  const stub: IProfessorAreaEvaluationsList = {
    id: PREVIEW_EVALUATION_ID,
    classroom_id: '',
    evaluation_id: '',
    evaluation_kind: 'objetive',
    evaluation_name: '',
    evaluation_type: evaluationType,
    kind: 'regular',
    max_attempts: 0,
    name: preview.name.trim() || fallbackName,
    parent_id: '',
    passing_score: 0,
    pending_evaluation_attempts_count: 0,
    replacements: [],
    requirements: [],
    rule: '',
    weight: String(
      Math.max(0, Number.isFinite(preview.weight) ? preview.weight : 0)
    )
  };

  return [...base, stub];
}
